const state = {
  showLogin: false,
  isLogin: false,
  searchObj: {}, // 查询对象
  newAddress: {}, // 新增修改Receiving address
  areaCode: [], // 当前区域编号
  currentPro: {}, // 当前商品
  userInfo: {
    headImage: ''
  }, // 当前用户信息
  shoppingCart: {}, // 购物车列表
  cartNumber: '', // 购物车数量
  evaluateOrders: {}, // 评价订单
  noticeId: {}, // 公告id
  collectData: {} // Shops数据
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js